// extracted by mini-css-extract-plugin
export var card = "card__TntVK";
export var unsubscribePage = "unsubscribePage__QfxEN";
export var optInPage = "optInPage__TdSd0";
export var container = "container__diiuu";